<template>
  <v-row no-gutters class="d-flex flex-column flex-sm-row justify-end">
    <v-col sm="3" cols="auto" class="d-flex justify-end">
      <v-card class="pa-2 pl-0 text-right d-flex flex-column" flat color="transparent">
        <label :id="'expectedHoursHeader-' + idPrefix" class="overline darkgrey-tableheader">Soll</label>
        <label :id="'expectedHours-' + idPrefix">{{displayData.hours.expected}}</label>
      </v-card>
    </v-col>
    <v-col sm="3" cols="auto" class="d-flex justify-end">
      <v-card
        :id="'presenceDetails-' + idPrefix"
        class="pa-2 pl-0 text-right"
        :hidden="visibility.hideHoursWorked"
        flat
        color="transparent"
      >
        <div class="d-flex flex-column">
          <label :id="'presenceHoursHeader-' + idPrefix" class="overline darkgrey-tableheader">Haben</label>
          <label :id="'presenceHours-' + idPrefix">{{displayData.hours.presences}}</label>
        </div>
      </v-card>
    </v-col>
    <v-col sm="3" cols="auto" class="d-flex justify-end">
      <v-card
        :id="'presenceDiffDetails-' + idPrefix"
        class="pa-2 pl-0 text-right"
        :hidden="visibility.hideHoursWorked"
        flat
        color="transparent"
      >
        <div class="d-flex flex-column">
          <label :id="'presenceDiffHeader-' + idPrefix" class="overline darkgrey-tableheader">Diff</label>
          <label :id="'presenceDiff-' + idPrefix">{{makeNumberSigned(displayData.hours.presenceDiff)}}</label>
        </div>
      </v-card>
    </v-col>
    <v-col sm="3" cols="auto" class="d-flex justify-end">
      <v-card class="pa-2 pl-0 text-right d-flex flex-column" flat color="transparent">
        <label :id="'flexTimeBalanceHeader-' + idPrefix" class="overline darkgrey-tableheader">Gleitzeit</label>
        <label :id="'flexTimeBalance-' + idPrefix">
          <label
            v-if="hours < 0"
            class="red--text"
          >{{formattedHours}}</label>
          <label v-else class="green--text">
            {{formattedHours}}
          </label>
        </label>
      </v-card>
    </v-col>
  </v-row>
</template>


<script lang='js'>
  import StatusColorCalculator from '@/mixins/StatusColorCalculator.vue';

  export default {
    name: 'HoursSummary',
    props: ['displayData', 'visibility', 'extrapolateFlexTime'],
    mixins: [StatusColorCalculator],
    data() {
      return {
        idPrefix: this.displayData.date ?? this.displayData.calendarWeek // TODO gibt es hier wirklich ein .date?
      }
    },
    created() {
      // this.extrapolated = this.extrapolateFlexTime && this.displayData.hours.extrapolated;
    },
    computed: {
      extrapolated() {
        return this.extrapolateFlexTime && this.displayData.hours.extrapolated;
      },
      hours() {
        return this.extrapolated ? this.displayData.hours.flexTimeBalanceExtrapolated : this.displayData.hours.flexTimeBalance;
      },
      formattedHours() {
        if (this.extrapolated) {
          return `(${this.makeNumberSigned(this.hours)})`;
        } else {
          return this.makeNumberSigned(this.hours);
        }
      }
    }
  }
</script>